import React from 'react';
import { Col, Row } from 'react-bootstrap';
const TopRowTitle = _ref => {
  let {
    title,
    showTopLine = true
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, showTopLine && /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, title), /*#__PURE__*/React.createElement(Col, {
    md: 5
  })));
};
export default TopRowTitle;